import React, {Component} from 'react';
import { connect } from 'react-redux';
import Pagination from 'react-js-pagination';
import {getSchoolLog} from './ducks';
import locale from './locale'
import moment from 'moment'
import {PanelWrapper} from 'components/UI'
import { isReturnStatement } from 'typescript';
import FilterBy from 'template/FilterBy';
import Loading from 'components/UI/Loading'
import __R, {userCan} from 'containers/__R';
import ActivityLog from 'components/Form/Fields/ActivityLog'

const itemsCountPerPage = 20;

const FILTER_OPTIONS = {
  teacher: {
    selectMultiple: false,
    onlyFetchCurrent: false,
  }
}
const mapStateToProps = state => ({
  schoolLog: state.schoolLog,
  subscription: state.gSubscription,

});

const mapDispatchToProps = dispatch => {
  return {
    getSchoolLog: (schoolId, params) => dispatch(getSchoolLog(schoolId, params)),
  };
}

class Logs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterData: {},
      filterTypes: ['teacher', 'daterange'],
      activePage: 1
    }

    this.onFilterChange = this.onFilterChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.isOutsideRange = this.isOutsideRange.bind(this);
    this.fetchLogs = this.fetchLogs.bind(this);

  }
  componentWillMount(){
    this.setState({
      defaultStartDate: moment().subtract(29, 'days')
    },()=>{
      this.fetchLogs();
    })
  }

  componentWillReceiveProps(nextProps){
    if(JSON.stringify(this.props.subscription.result) !== JSON.stringify(nextProps.subscription.result)){      
      this.setState({
        defaultStartDate: moment().subtract(29, 'days')
      }, () => {
        this.fetchLogs();
      })
    }
  }

  onFilterChange({ filterData }){
    this.setState({
      filterData,
    }, ()=>{
      this.fetchLogs();
    })
  }

  fetchLogs() {
    const schoolId = localStorage.getItem('schoolId');
    const { filterData, activePage } = this.state;
    const { teacher, daterange } = filterData; 

    let startEndDate = {
      start_date: this.state.defaultStartDate.format('YYYY-MM-DD')
    }
    if (daterange && daterange.startDate && daterange.endDate) {
      startEndDate = {
        start_date: daterange.startDate.format('YYYY-MM-DD'),
        end_date: daterange.endDate.format('YYYY-MM-DD'),
      }
    }
    let params = {
      school_teacher: teacher? teacher.IDs[0]: null,
      current_page_number: activePage,
      amount_per_page: itemsCountPerPage,
      ...startEndDate
    }
    this.props.getSchoolLog(schoolId, params);
  }

  handlePageChange(pageNumber){
    this.setState({activePage: pageNumber},()=>{
      this.fetchLogs();
    });
  }
  
  isOutsideRange(day){
    let startingDate = moment().subtract(30, 'days')
    return day.isAfter(moment()) || day.isBefore(startingDate);
  }

  render () {
    const schoolId = localStorage.getItem('schoolId')
    const { activePage, filterData } = this.state;
    const { fetching, logs } = this.props.schoolLog;
    const totalTaskAmount = logs.total_task_amount;
    const daterangeOptions = {
      startDate: filterData.daterange && filterData.daterange.startDate ? filterData.daterange.startDate : this.state.defaultStartDate,
      endDate: filterData.daterange && filterData.daterange.endDate ? filterData.daterange.endDate : '',
      // endDatePlaceholderText: __('Today', 'teacherAttendance'),
      isOutsideRange: this.isOutsideRange
    }
    const {result_list} = this.props.schoolLog.logs

    if(!result_list || fetching){
      return (<Loading />)
    }


    return (
      <PanelWrapper className='log-container' title={__('Activity Log', locale)}>
        <FilterBy 
          filterData={this.state.filterData}
          selectMultiple={true}
          filters={this.state.filterTypes}
          options={{...FILTER_OPTIONS, daterange: daterangeOptions}}
          schoolId={schoolId}
          onChange={this.onFilterChange}
        />

        <ActivityLog resultList={result_list} />

        <Pagination
          innerClass='pagination pull-left'
          activePage={activePage}
          itemsCountPerPage={itemsCountPerPage}
          totalItemsCount={totalTaskAmount}
          pageRangeDisplayed={5}
          onChange={this.handlePageChange}
        />
      </PanelWrapper>
    )
  }
}



export default connect(mapStateToProps, mapDispatchToProps)(Logs);



// WEBPACK FOOTER //
// ./src/containers/pages/Logs/index.js